import { PLATFORM_DOMAIN } from '@/lib/tenant'
import type { SportCatalogEntry } from '@/api/types'
import { Card, CardHeader, KeyValueList } from '@/components/ui'
import { ADDONS, enabledAddons } from '@/lib/addons'
import { formatDate, titleCase } from '@/lib/format'
import { effectiveSubdomain, trialDaysError, type Draft } from './draft'

const dash = <span className="text-subtle">—</span>

/** Live summary beside the steps; on the last step it's the review. */
export function Summary({ draft, sports }: { draft: Draft; sports: SportCatalogEntry[] | undefined }) {
  const sub = effectiveSubdomain(draft)
  const sport = sports?.find((s) => s.id === draft.sport)?.display_name ?? titleCase(draft.sport)
  const on = enabledAddons(draft.addons)
  const days = Number(draft.trialDays)
  const trial = trialDaysError(draft.trialDays) ? dash : `${days} day${days === 1 ? '' : 's'}, ends ${formatDate(new Date(Date.now() + days * 86_400_000).toISOString())}`
  return (
    <Card>
      <CardHeader title="Summary" description="What Create sets up, in one step: the league, its sport and a trial on the plan; then the first admin is invited by email." />
      <KeyValueList
        items={[
          { label: 'Name', value: draft.name.trim() || dash },
          { label: 'Address', value: sub ? <span className="break-all font-mono text-xs">{`${sub}.${PLATFORM_DOMAIN}`}</span> : dash },
          { label: 'Sport', value: sport },
          {
            label: 'First admin',
            value: draft.skipAdmin ? (
              <span className="text-warn">None yet</span>
            ) : draft.adminEmail.trim() ? (
              <span className="break-all">{draft.adminEmail.trim()} (invited by email)</span>
            ) : (
              dash
            ),
          },
          { label: 'Trial', value: trial },
          { label: 'Package', value: draft.packageKey === 'standard' ? 'Standard' : 'No package' },
          { label: 'Add-ons', value: on.length ? on.map((k) => ADDONS[k].label).join(', ') : <span className="text-muted">None</span> },
          ...(draft.notes.trim() ? [{ label: 'Notes', value: draft.notes.trim() }] : []),
        ]}
      />
    </Card>
  )
}
